export default __webpack_public_path__ + "static/media/icon_facility_infor.bca85707.svg";